<template>
    <div class="position-relative">
        
        <div class="position-sticky" style="left: 1vw; width: calc(90vw - 250px);">
            <b-alert :show="data.deliveredLateReason != null" variant="warning">
                Delivered Late: {{ data.deliveredLateReason }}, {{ data.deliveredLateComments }}
            </b-alert>
            <ejs-grid :id="getInstallationAndVersionSpecificGridId('BillingManagementGridDetailRow')"
                      ref="billingManagementGridDetailRow"
                      :dataSource="gridData"
                      :dataBound="dataBound"
                      :rowDataBound="rowDataBound"
                      :queryCellInfo="customiseCell"
                      :editSettings="editSettings"
                      :allowResizing="true"
                      :actionBegin="actionBegin">
                <e-columns>
                    <e-column field="description" headerText="Description" :allowEditing="false"></e-column>
                    <e-column field="quantity" headerText="Quantity" editType="numericedit" width="100"></e-column>
                    <e-column field="unitCost" headerText="Rate" editType="numericedit" width="100"></e-column>
                    <e-column field="chargeable" headerText="Chargeable" editType="booleanedit" width="100"></e-column>
                    <e-column field="splitPercentage" headerText="Split Costs" editType="numericedit" width="100"></e-column>
                    <e-column field="totalCost" headerText="Total Amount" editType="numericedit" width="100"></e-column>
                    <e-column field="billLater" headerText="Bill Later" editType="booleanedit" width="100"></e-column>
                    <e-column v-if="!data.billLater && data.canModifyBillingData && !data.markedForInvoicing" headerText='Manage Items' width='100' :commands='commands'></e-column>
                </e-columns>
            </ejs-grid>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import NumbersMixin from '../../mixins/NumbersMixin';
    import GridMixins from '../../mixins/GridMixins';
    import axios from 'axios';


    import { GridPlugin, ColumnChooser, Resize, Sort, Group, Page, Toolbar, Edit, Search, ExcelExport, ContextMenu, CommandColumn } from '@syncfusion/ej2-vue-grids';
    Vue.use(GridPlugin);

    export default {
        name: 'BillingManagementGridDetailRow',
        emits: {
            updateLogEntry: null,
        },
        provide: {
            grid: [ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport, ContextMenu, Edit, CommandColumn],
        },
        mixins: [DateTimeMixin, NumbersMixin, GridMixins],
        inject: {
            eventBus: { from: 'eventBus' }
        },
        data() {
            return {
                data: { serviceItems: [] },

                commands: [{ type: 'Edit', buttonOption: { iconCss: 'fas fa-edit' } },
                { type: 'Save', buttonOption: { iconCss: 'fas fa-save' } },
                { type: 'Cancel', buttonOption: { iconCss: 'fas fa-times' } }],

                pageNumber: 0,
                emptyExecutionsEnabled: false,
                columnFormats: {
                    'unitCost': {
                        type: 'currency',
                    },
                    'totalCost': {
                        type: 'currency',
                    },
                    'splitPercentage': {
                        type: 'percentage',
                    }
                },
                //editSettings: { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal' },
                splitCosts: false,
                splitCostsPercentage: null,
                gridData: [],
                errors: '',
            }
        },
        computed: {
            editSettings: function () {
                var canUpdateLineItems = !this.data.billLater && this.data.canModifyBillingData && !this.data.markedForInvoicing;
                return {
                    allowEditing: canUpdateLineItems,
                    allowAdding: canUpdateLineItems,
                    allowDeleting: canUpdateLineItems,
                    mode: 'Normal'
                }
            },
        },
        methods: {
            dataBound: function () {
            },
            rowDataBound: function (args) {
                //if (this.data.selectedEntry != undefined &&
                //    this.data.selectedEntry != null &&
                //    args.data.workLogEntryId == this.data.selectedEntry)
                args.row.classList.add('billing-management');
                if (!args.data.chargeable)
                    args.row.classList.add('non-chargeable');
                else if (args.data.billLater)
                    args.row.classList.add('bill-later');


                return;
            },
            customiseCell: function (args) {
                switch (args.column.field) {
                    case 'quantity':
                        args.cell.textContent = args.data.quantity + " " + args.data.unit;
                        break;
                    case 'chargeable':
                        args.cell.textContent = args.data.chargeable ? 'Yes' : 'No';
                        break;
                    case 'splitPercentage':
                        if (args.data.splitPercentage == null || args.data.splitPercentage == 0 || args.data.splitPercentage == 100)
                            args.cell.textContent = 'No';
                        else args.cell.textContent = (Math.round(args.data.splitPercentage * 100) / 100).toFixed(2) + "%";
                        break;
                    case 'billLater':
                        if (args.data.nonProductionChargeId == null)
                            args.cell.textContent = 'N/A';
                        else
                            args.cell.textContent = args.data.billLater ? 'Yes' : 'No';
                        break;
                    default:
                        this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);
                        break;
                }
            },
            contextMenuOpened: function (args) {
                if (args.rowInfo.rowData === undefined || args.rowInfo.rowData == null) {
                    args.cancel = true;
                    return;
                }

                var contextMenuObj = this.$refs.dataRetentionExecutionGridRow.ej2Instances.contextMenuModule.contextMenu;
                var item = args.rowInfo.rowData;
                var hasItems = false;

                if (item.status.stringValue != "ConfirmationRequired") contextMenuObj.hideItems(["confirmexecution"], true);
                else {
                    contextMenuObj.showItems(["confirmexecution"], true);
                    hasItems = true;
                }

                if (item.status.stringValue != "Success" || item.matchingAttachments == 0) contextMenuObj.hideItems(["viewfiles"], true);
                else {
                    contextMenuObj.showItems(["viewfiles"], true);
                    hasItems = true;
                }

                if (item.status.stringValue != "ConfirmationRequired") contextMenuObj.hideItems(["confirmexecution"], true);
                else {
                    contextMenuObj.showItems(["confirmexecution"], true);
                    hasItems = true;
                }

                if (!hasItems) args.cancel = true;
            },
            contextMenuClicked: function (args) {
                if (args.item.id === 'confirmexecution' || args.item.id === 'viewfiles') {
                    if (args.rowInfo === undefined || args.rowInfo.rowData === undefined) return;
                    this.handleAction(args.item.id, args.rowInfo.rowData);
                }
            },
            handleAction: function (action, selectedRow) { //, selectedRow
                //var row = {};
                switch (action) {
                    case ('confirmexecution'):
                        this.confirmExecution(selectedRow.dataRetentionExecutionId);
                        break;
                    default:
                        break;
                }
            },
            actionBegin: function (args) {

                switch (args.requestType) {
                    case 'beginEdit':
                        if (args.rowData.nonProductionChargeId == null) {
                            this.grid.columnModel.filter(function (column) {
                                if (column.field == 'quantity') column.allowEditing = false;
                                if (column.field == 'totalCost') column.allowEditing = false;
                                if (column.field == 'billLater') column.allowEditing = false;
                            });
                        }
                        else {
                            this.grid.columnModel.filter(function (column) {
                                if (column.field == 'quantity') column.allowEditing = true;
                                if (column.field == 'totalCost') column.allowEditing = true;
                                if (column.field == 'billLater') column.allowEditing = true;
                            });
                        }
                        break;
                    case 'save':
                        if (args.data.splitPercentage != null) {
                            if (args.data.splitPercentage < 1) args.data.splitPercentage = null;
                            if (args.data.splitPercentage > 99) args.data.splitPercentage = null;
                        }
                        if ((args.data.quantity != null) && (args.data.unitCost != null) && (args.data.totalCost != null)) {
                            if (args.data.totalCost != args.previousData.totalCost) {
                                //the user has changed the total cost for a non production charge - we will calculate the unit cost
                                args.data.unitCost = args.data.totalCost / args.data.quantity;
                            } else {
                                args.data.totalCost = args.data.unitCost * args.data.quantity;
                            }
                        }
                        this.updateLineItem(args.data);
                        break;
                    default:
                        break;
                }


            },
            canUpdateLineItems: function () {
                if (this.data.bilLater) return false;
                return true;
            },
            updateLineItem: function (lineItem) {
                var url = this.$urlHelper.getApiUrl('billingmanagement', 'updatecosts');
                return axios
                    .post(url, JSON.stringify(lineItem), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {

                        this.eventBus.$emit('updatetotal', { total: response.data, key: this.data.key });
                        //this.$bvToast.toast('Successfully updated Line Item.', {
                        //    title: 'Updated',
                        //    variant: 'success',
                        //    appendToast: true
                        //});
                    })
                    .catch(ex => {
                        // var errors = this.handleAxiosException(ex);
                        //this.showErrorsToast(ex);
                        this.errors = ex;
                        return false;
                    });
            },

            loadAdditionalCharges: function () {

                //if (gridDataState.filter == null) {
                //    this.grid.localeObj.localeStrings.EmptyRecord = "Apply a filter to see results";
                //    return Promise.resolve({ count: 0, result: [] });
                //}
                //this.grid.localeObj.localeStrings.EmptyRecord = "No records to display";

                //var url = this.apiBaseUrl + '/billingmanagement/listcosts/' + this.data.orderId + '/' + this.data.workItemId;

                return axios
                    .get(this.$urlHelper.getApiUrl('billingmanagement', 'listcosts', [this.data.orderId, this.data.workItemId]))
                    .then(response => {
                        this.gridData = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });


                //return axios
                //    .get(url)
                //    .then(response => {
                //        var gridData = response.data;


                //        if (gridData && gridData.result) {
                //            gridData.result = gridData.result.map((workItem) => {
                //                //IMPORTANT! ALL date/time properties have to be converted from strings to 'proper' date/time value here
                //                if (workItem.createdDateTimeUTC) workItem.createdDateTimeUTC = this.parseDateTime(workItem.createdDateTimeUTC, true, false);
                //                if (workItem.confirmedDateTimeUTC) workItem.confirmedDateTimeUTC = this.parseDateTime(workItem.confirmedDateTimeUTC, true, false);
                //                if (workItem.orderedDateTimeUTC) workItem.orderedDateTimeUTC = this.parseDateTime(workItem.orderedDateTimeUTC, true, false);
                //                if (workItem.dueDateTimeUTC) workItem.dueDateTimeUTC = this.parseDateTime(workItem.dueDateTimeUTC, true, false);
                //                if (workItem.mergedDateTimeUTC) workItem.mergedDateTimeUTC = this.parseDateTime(workItem.mergedDateTimeUTC, true, false);
                //                if (workItem.checkedDateTimeUTC) workItem.checkedDateTimeUTC = this.parseDateTime(workItem.checkedDateTimeUTC, true, false);
                //                if (workItem.completedDateTimeUTC) workItem.completedDateTimeUTC = this.parseDateTime(workItem.completedDateTimeUTC, true, false);
                //                if (workItem.sittingDate) workItem.sittingDate = this.parseDateTime(workItem.sittingDate, true, true);
                //                if (workItem.orderedDate) workItem.orderedDate = this.parseDateTime(workItem.orderedDate, true, false);
                //                if (workItem.sittingStartTime) workItem.sittingStartTime = this.parseDateTime(workItem.sittingStartTime, true, true);
                //                if (workItem.sittingEndTime) workItem.sittingEndTime = this.parseDateTime(workItem.sittingEndTime, true, true);
                //                if (workItem.interviewDateTime) workItem.interviewDateTime = this.parseDateTime(workItem.interviewDateTime, true, true);
                //                if (workItem.startTime) workItem.startTime = this.parseDateTime(workItem.startTime, true, true);
                //                if (workItem.endTime) workItem.endTime = this.parseDateTime(workItem.endTime, true, true);
                //                return workItem;
                //            });
                //        }
                //        this.gridData = gridData;
                //    })
                //    .catch(ex => {
                //        var errors = this.handleAxiosException(ex);
                //        this.showErrorsToast(errors);
                //        return false;
                //    });
            },


        },

        mounted: function () {
            this.grid = this.$refs.billingManagementGridDetailRow.ej2Instances;
            this.loadAdditionalCharges();
        }


    }







</script>



